import type { Drug } from "../types";

export const amoxicillinDrug: Drug = {
  id: "amoxicillin",
  name: "Amoxicillin",
  drugClass: "penicillin",
  defaultFoodTiming: "Take with food or water",
  foodTiming: "Take with food or water",
  swallowingNote: "Capsules should be swallowed whole",
  paediatricLinkRefs: [
    "medicines-for-children-amoxicillin",
    "medicines-for-children-giving-capsules",
  ],
  formulations: [
    {
      id: "amox-250-cap",
      type: "capsule_ir",
      strength: 250,
      strengthUnit: "mg",
      prescribedItemId: "e05f3085-046d-481e-a538-12f5e31164d6",
    },
    {
      id: "amox-500-cap",
      type: "capsule_ir",
      strength: 500,
      strengthUnit: "mg",
      prescribedItemId: "a01848b0-decf-47fd-aec0-a5240d096464",
    },
    {
      id: "amox-125-5ml",
      type: "oral_suspension",
      strength: 125,
      strengthUnit: "mg",
      volumePer: 5,
      volumeUnit: "mL",
      bottleSize: 100,
      bottleSizeUnit: "mL",
      sugarFreeAvailable: true,
      prescribedItemId: "eef738e2-ee1b-47c1-9531-4c3779eed3e7",
    },
    {
      id: "amox-250-5ml",
      type: "oral_suspension",
      strength: 250,
      strengthUnit: "mg",
      volumePer: 5,
      volumeUnit: "mL",
      bottleSize: 100,
      bottleSizeUnit: "mL",
      sugarFreeAvailable: true,
      prescribedItemId: "01ac8b04-ef91-4a02-9f08-4aed052c0d94",
    },
    {
      id: "amox-500-5ml",
      type: "oral_suspension",
      strength: 500,
      strengthUnit: "mg",
      volumePer: 5,
      volumeUnit: "mL",
      bottleSize: 100,
      bottleSizeUnit: "mL",
      sugarFreeAvailable: true,
    },
  ],
};
